<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch9" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT"><span aria-label="13" id="pg_13" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch9" id="ch9" title="Link target outside of Sample"><b><i>An Autumn Soul</i></b></span></span></h1>
</header>
<blockquote>
<p class="VSB">One day the leaves begin to change,</p>
<p class="VSB">along with the love you thought you were in.</p>
<p class="V">You blink against your will, and feel your</p>
<p class="VSB">heart begin to unravel …</p>
<p class="V">shredding into pieces, as the person who you</p>
<p class="V">deemed different begins to change along with</p>
<p class="VSB">the season.</p>
<p class="VSB">You mouth goodbye as he blends in</p>
<p class="V">with hues of bad decisions,</p>
<p class="VSB">jack-o-lantern masks,</p>
<p class="VSB">and pumpkin-spiced kisses.</p>
<p class="VSB">And you know how the leaves feel</p>
<p class="VSB">as they fall, dying, onto the ground.</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter9.vue?13591ce7